var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "dashboard-v1" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 40 } },
          [
            _c(
              "el-col",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingProfile,
                    expression: "loadingProfile"
                  }
                ],
                attrs: { xs: 24, sm: 24, lg: 12 }
              },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "load-up",
                    staticStyle: { "margin-bottom": "30px" },
                    attrs: { gutter: 40 }
                  },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("div", { staticClass: "card-top-left card-style" }, [
                        _c(
                          "div",
                          {
                            staticClass: "card-icon card-height",
                            staticStyle: { background: "Teal" }
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "3em",
                                    color: "White"
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-envelope" })]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-content card-height" }, [
                          _c("div", [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "dashboard.agent.enterpriseRechargeTotal"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "value" },
                              [
                                _c("count-to", {
                                  staticClass: "card-panel-num",
                                  attrs: {
                                    "start-val": 0,
                                    "end-val": _vm.profile.organizationAmount,
                                    duration: 2600
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("div", { staticClass: "card-top-left card-style" }, [
                        _c(
                          "div",
                          {
                            staticClass: "card-icon card-height",
                            staticStyle: { background: "SlateBlue" }
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "3em",
                                    color: "White"
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-city" })]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-content card-height" }, [
                          _c("div", [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("dashboard.agent.numOfOrgs")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "value" },
                              [
                                _c("count-to", {
                                  staticClass: "card-panel-num",
                                  attrs: {
                                    "start-val": 0,
                                    "end-val":
                                      _vm.profile
                                        .organizationNumberActiveInLastTenDay,
                                    duration: 2600
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "info-panel card-style load-up" },
                        [
                          _c("div", { staticClass: "icon-profile" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/logo.png"),
                                alt: "",
                                width: "150",
                                height: "150"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "greeting" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("dashboard.goodAfternoon")) +
                                "，" +
                                _vm._s(_vm.user.agentAccount) +
                                "，" +
                                _vm._s(_vm.$t("dashboard.welcome")) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "login-info" }, [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "info",
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { width: "130px" } },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("dashboard.lastLoginTime")
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                      ：" +
                                        _vm._s(_vm.user.lastLoginTime) +
                                        "\n                    "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticStyle: { width: "130px" } }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("dashboard.lastLoginIp")) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                      ：" +
                                      _vm._s(_vm.user.lastLoginIp) +
                                      "\n                    "
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { xs: 24, sm: 24, lg: 12 } },
              [
                _c(
                  "el-row",
                  _vm._l(_vm.cardInfo, function(info, i) {
                    return _c("CardInfo", { key: i, attrs: { info: info } })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              [
                _c("el-row", [
                  _c("div", { staticClass: "card-style" }, [
                    _c(
                      "div",
                      { staticClass: "chart-wrapper load-up" },
                      [
                        _c("div", { staticClass: "graph-title" }, [
                          _vm._v(_vm._s(_vm.$t("dashboard.agent.top5Orgs")))
                        ]),
                        _vm._v(" "),
                        _vm.values.length
                          ? _c("bar-chart", {
                              ref: "barChart",
                              attrs: {
                                labels: _vm.labels,
                                values: _vm.values,
                                placeholder: _vm.$t("dashboard.agent.SmsSent")
                              }
                            })
                          : _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("common.noData")))
                            ])
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }